module.exports = __webpack_public_path__ + "static/img/pc-web-img03-04@t.81f2aa5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hos/pc-web-img03-04@t.png
// module id = 836Z
// module chunks = 0